import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import ImmersivePortfolio from './pages/ImmersivePortfolio';

function App() {
  return (
    <ThemeProvider>
      <ImmersivePortfolio />
    </ThemeProvider>
  );
}

export default App;
